import { Outlet } from "react-router-dom";

export default function SalesPage() {
  return (<div> 
      <Outlet/>
  </div>);
}